import { date } from 'quasar'
import ChargeBeeInvoicesMonitoringLogViewModel from '../chargebeeinvoicesmonitoringlogviewmodel-dialog-screen.vue';


export default {
    data: function () {
        return {
            loading: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID
            model: { },
            filter: null,
            channelSettings: {
                ApplicationId: 0
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                },
                {
                    name: 'Status',
                    label: 'Status',
                    align: 'left',
                    field: row => row.Status,
                    sortable: false,
                    style: '',
                    
                },
                {
                    name: 'EventDate',
                    label: 'Event Date',
                    align: 'left',
                    field: row => row.EventDate,
                    sortable: true,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY'),
                },
                {
                    name: 'InvoiceId',
                    label: 'Invoice Id',
                    align: 'left',
                    field: row => row.InvoiceId,
                    sortable: true,
                    style: '',
                    
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },

            ],
            columnsVisible: ['Status', 'EventDate', 'InvoiceId', 'Actions'],
            dataSource: [],
            selected: [],
            editRowKey: null,
            pagination: {
                sortBy: 'EventDate',
                descending: true,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            },
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
            });
        },

        refreshScreen() {
            if (this.channelSettings.ApplicationId > 0) {
                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.dataSource = [];
            }
        },

        onChargeBeeInvoicesMonitoringLoglDetailsActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                component: ChargeBeeInvoicesMonitoringLogViewModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Details',
                actionTitle: 'Details',
                editMode: false
            }).onOk((payload) => {
                // None post action
            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/charge_bee_invoices_monitoring_log/byApplication/' + this.channelSettings.ApplicationId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                
                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        
    },

    computed: {
        screenTitle: function () {
            return 'ChargeBee Invoices Monitoring';
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}